import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=0d778daa"
import script from "./Leave.vue?vue&type=script&lang=js"
export * from "./Leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports